import Styles from 'components/Wizards/BlogPostWizard/BlogPostWizard.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { LinksLoadingState } from '../BlogPostWizard/LinksLoadingState'
import { Spinner } from 'common/Spinner/Spinner'

export const LinkGenerationLoading = () => {
  return (
    <>
      <LinksLoadingState count={5} />
      <div className={cx(Styles.loadingText)}>
        <Text variant="secondary" color="var(--dark-100)">
          Searching for the best links related to your purpose and goals
        </Text>
        <Spinner />
      </div>
    </>
  )
}
